<div class="sidebar">
    <app-sidebar-header [title]="INDRA_printSidebarTitle()" [label]="INDRA_printSidebarLabel()" [show_custom_button]="true">
        <div custom-button>
            <button class="close" aria-role="button" [attr.aria-label]="'addMoreSidebars.seatmap.aria.closeDialog' |  ibeadmin:'sync' " (click)="!isModificationDisallowed ? INDRA_handleClose() : INDRA_closeSidebar()">
				<div class="close__icon-wrapper">
					<app-svg class="header-breadcrumb__icon"
									 svg="icons.svg#general--arrow--left-no_margin"
									 aria-hidden="true"
									 [alt]="'addMoreSidebars.seatmap.alt.arrowLeft' | ibeadmin: 'sync'">
					</app-svg>
				</div>
			</button>
        </div>
        <div actions *ngIf="INDRA_showSaveSidebarHeader()">
            <button class="button button--small" [disabled]="INDRA_disableSave()" (click)="INDRA_saveSidebar()">
				{{ 'addMoreSidebars.seatmap.button.save' | ibeadmin:'sync'}}
			</button>
        </div>
    </app-sidebar-header>

    <div class="sidebar-subheader" *ngIf="
			!seatCharacteristicsOpen &&
			!emergencySeatNotificationOpen &&
			!saveConfirmationInfoOpen">
        <app-flight-route *ngIf="flight" class="no-margin" [flight]="flight"></app-flight-route>

        <div class="sidebar-subheader--flight-info" *ngIf="stops.length > 1 && !isLoadingSeatmap">

            <p>
                {{ 'addMoreSidebars.seatmap.text.flightHas' | ibeadmin:'sync'}} {{stops.length - 1}} {{ 'addMoreSidebars.seatmap.text.stop' | ibeadmin:'sync'}}, {{ 'addMoreSidebars.seatmap.text.chooseSeatForEachTrip' | ibeadmin:'sync'}}
            </p>

            <app-segmented-control-radio classes="sidebar-subheader--flight-info--options" (selected)="INDRA_selectedStop($event)" [_value]="selectedStop" [options]="stops" [loading]="isLoadingSegment">
            </app-segmented-control-radio>

        </div>

        <ng-container *ngIf="INDRA_avaibleForFlight()">
            <div class="seat-columns">
                <div class="seat-columns__wrapper">
                    <div class="seat-columns__row">
                        <div class="seat-columns__letter" [ngClass]="INDRA_letterStyle(seatColumn, index)" *ngFor="
							let seatColumn of planeSeatColumns;
							let index = index;
							trackBy: trackByFn">
                            {{ seatColumn.index }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div tabindex="0" #sidebar__body id="sidebar__body" class="sidebar__body sl--scrollable seatmap seatmap_{{ airPlane }}">

        <ng-container *ngIf="((isLoadingSeatmap || INDRA_seatmapIsLoadded()) && !addedByPack) else disableForFlight">

            <!-- Seat Selection Error -->
            <div *ngIf="selectionApiError" class="seatmap__body-content-wrapper">
                <app-notification [style]="'alert'" [classes]="'alert-sidebar'" [icon]="'icons.svg#airport--delays'" title="{{'addMoreSidebars.seatmap.title.operationError' | ibeadmin:'sync'}}">
                    <div message>{{'addMoreSidebars.seatmap.text.operationError' | ibeadmin:'sync'}}</div>
                </app-notification>
            </div>

            <!-- LOADING -->
            <app-loading *ngIf="isLoadingSeatmap"></app-loading>

            <!-- SEATMAP -->
            <div class="seatmap__plane-wrapper seatmap__body-content-wrapper" *ngIf="
				!seatCharacteristicsOpen &&
				!emergencySeatNotificationOpen &&
				!saveConfirmationInfoOpen &&
				!isLoadingSeatmap &&
				INDRA_seatmapIsLoadded() &&
                !selectionApiError">
                <div class="seatmap__plane">
                    <div class="seatmap__cockpit">
                        <app-svg svg="sprite.svg#plane--cockpit" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.planeCockpit' | ibeadmin: 'sync'"></app-svg>
                    </div>

                    <div class="seatmap__not-available-cabin__wrapper" *ngIf="INDRA_showCabinClassBusinessContainer()">
                        <div class="seatmap__not-available-cabin">{{'addMoreSidebars.seatmap.text.businessCabin' | ibeadmin:'sync'}}</div>
                    </div>

                    <ng-container *ngFor="let cabin of seatmap.cabins; index as i; trackBy: trackByFn">
                        <ng-container *ngFor="let row of cabin.rows; trackBy: trackByFn">
                            <div class="seatmap__cabin" [ngClass]="{'seatmap__cabin--business': cabin.location === 'C', 'seatmap__cabin--economy': cabin.location === 'Y'}">

                                <div class="seatmap__facilities seatmap__facilities--lavatory" *ngIf="INDRA_displayWCCabinFacility(cabin, 'before', row.index)">
                                    {{'addMoreSidebars.seatmap.text.wcRow' | ibeadmin:'sync'}}
                                </div>

                                <app-seatmap-row (handleSeatClick)="!isModificationDisallowed ? INDRA_handleSeatClick($event) : return;" [selectedSeat]="selectedSeat" [choosedSeats]="choosedSeats" [row]="row" [planeWing]="planeWing" [cabin]="cabin" [segmentSelected]="flightStop" [previouslyBoughtSeats]="previouslyBoughtSeats"
                                    [previouslyBoughtSeatsBeforeEdit]="previouslyBoughtSeatsBeforeEdit" [featuresAddedBeforeEdit]="featuresAddedBeforeEdit" [passengers]="INDRA_getPassengers()" [allPaxAreUnaccompaniedMinor]="allPaxAreUnaccompaniedMinor" [hasHandicapped]="hasHandicapped"
                                    [hasInfant]="hasInfant" [allPaxWithWCHC]="allPaxWithWCHC" [allPaxWithWCHCorWCHS]="allPaxWithWCHCorWCHS" [isPortugaliaOperatedFlight]="isPortugaliaOperatedFlight" [flight]="flight" [seatFeatures]="seatFeatures">
                                </app-seatmap-row>

                                <div class="seatmap__facilities seatmap__facilities--lavatory" *ngIf="INDRA_displayWCCabinFacility(cabin, 'after', row.index)">
                                    {{'addMoreSidebars.seatmap.text.wcRow' | ibeadmin:'sync'}}
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <div class="seatmap__not-available-cabin__wrapper" *ngIf="INDRA_showCabinClassEconomyContainer()">
                        <div class="seatmap__not-available-cabin">
                            {{'addMoreSidebars.seatmap.text.economyCabin' | ibeadmin:'sync'}}
                        </div>
                    </div>

                    <div class="seatmap__plane-tail"></div>
                </div>
            </div>

            <!-- CHARACTERISTICS -->
            <div class="seatmap__body-content-wrapper" tabindex="-1" *ngIf="this.seatCharacteristicsOpen && !isLoadingSeatmap" cdkTrapFocus>

                <div class="seat-charact seat-charact--compare" *ngFor="let prop of INDRA_getSeatCharacteristicsProps(); trackBy: trackByFn">
                    <div class="seat-charact-header">
                        <div class="seat-charact-title">
                            <div *ngIf="!seatCharacteristics[prop].icon" class="seatmap__seat seat--{{seatCharacteristics[prop].cssClass}}"></div>
                            <app-svg *ngIf="seatCharacteristics[prop].icon" [svg]="seatCharacteristics[prop].icon" [alt]="seatCharacteristics[prop].label" class="seat-charact-icon" aria-hidden="true">
                            </app-svg>
                            <h5 class="title-h5" *ngIf="!seatCharacteristics[prop].image">
                                <!-- {{ seatCharacteristics[prop].label | ibeadmin:'sync'}} -->
                                <ng-container [ngSwitch]="seatCharacteristics[prop].cssClass">
                                    <span *ngSwitchCase="'comfort'">
                                        {{'addMoreSidebars.seatmap.text.comfortSeat' | ibeadmin:'sync'}}
                                    </span>
                                    <span *ngSwitchCase="'standard'">
                                        {{'addMoreSidebars.seatmap.text.standardSeat' | ibeadmin:'sync'}}
                                    </span>
                                    <span *ngSwitchCase="'business'">
                                        {{'addMoreSidebars.seatmap.text.executiveSeat' | ibeadmin:'sync'}}
                                    </span>
                                    <span *ngSwitchDefault>
                                        {{'addMoreSidebars.seatmap.text.emergencyExit' | ibeadmin:'sync'}}
                                    </span>
                                </ng-container>
                            </h5>
                            <!-- <app-svg *ngIf="seatCharacteristics[prop].image" [svg]="seatCharacteristics[prop].image" [alt]="seatCharacteristics[prop].label" class="seat-charact-logo {{seatCharacteristics[prop].svgCssClass}} right-gap">
                            </app-svg> -->
                            <h5 class="title-h5" *ngIf="seatCharacteristics[prop].image">
                                <ng-container [ngSwitch]="seatCharacteristics[prop].cssClass">
                                    <span *ngSwitchCase="'comfort'">
                                        {{'addMoreSidebars.seatmap.text.comfortSeat' | ibeadmin:'sync'}}
                                    </span>
                                    <span *ngSwitchCase="'standard'">
                                        {{'addMoreSidebars.seatmap.text.standardSeat' | ibeadmin:'sync'}}
                                    </span>
                                    <span *ngSwitchCase="'business'">
                                        {{'addMoreSidebars.seatmap.text.executiveSeat' | ibeadmin:'sync'}}
                                    </span>
                                    <span *ngSwitchDefault>
                                        {{'addMoreSidebars.seatmap.text.emergencyExit' | ibeadmin:'sync'}}
                                    </span>
                                </ng-container>
                            </h5>
                        </div>
                        <!-- commented out in Phase 1
						<h5 class="title-h5" *ngIf="seatCharacteristics[prop].price">
							{{ seatCharacteristics[prop].price + INDRA_getSeatmapCurrencySymbol() | indracurrency }}
						</h5> -->
                    </div>
                    <div #sidebar__info class="sidebar__info">
                        <ul class="vantages-listing" *ngFor="
							let feature of seatCharacteristics[prop].features;
							trackBy: trackByFn
						">
                            <li>{{ feature | ibeadmin:'sync'}}</li>
                        </ul>
                        <a *ngIf="INDRA_showSeatPhotos(prop)" href="javascript:;" class="link bold seat-photos-link" tabindex="0" role="button" [attr.aria-label]="'addMoreSidebars.seatmap.aria.seatPhotos' | ibeadmin: 'sync'" (click)="INDRA_openSlideshow(prop)">
                            <app-svg class="seat-photos-icon" svg="icons.svg#interface--gallery" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.gallery' | ibeadmin: 'sync'">
                            </app-svg>
                            {{'addMoreSidebars.seatmap.link.seatPhotos' | ibeadmin:'sync'}}
                        </a>
                    </div>
                </div>
                <div class="seat-charact-others">
                    <div class="seat-charact-legend">
                        <div class="seatmap__seat">
                            <app-svg class="seat-photos-icon" svg="icons.svg#special_needs--travelling_with_children" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.suitableForInfants' | ibeadmin: 'sync'">
                            </app-svg>
                        </div>
                        <h5 class="title-h5">
                            {{'addMoreSidebars.seatmap.title.suitableForInfants' | ibeadmin:'sync'}}
                        </h5>
                    </div>
                    <div class="seat-charact-legend">
                        <div class="seatmap__seat">
                            <app-svg class="seat-photos-icon" svg="icons.svg#special_needs--wheelchair_access" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.suitableForWheelChairs' | ibeadmin: 'sync'">
                            </app-svg>
                        </div>
                        <h5 class="title-h5">{{'addMoreSidebars.seatmap.title.suitableForWheelchairs' | ibeadmin:'sync'}}</h5>
                    </div>
                    <div class="seat-charact-legend">
                        <div class="seatmap__seat">
                            <app-svg class="seat-photos-icon" svg="icons.svg#money_related--payment" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.paidSeat' | ibeadmin: 'sync'">
                            </app-svg>
                        </div>
                        <h5 class="title-h5">{{'addMoreSidebars.seatmap.title.paidSeat' | ibeadmin:'sync'}}</h5>
                    </div>
                    <div class="seat-charact-legend">
                        <div class="seatmap__seat seat--not-available">
                            <app-svg class="seat-photos-icon" svg="icons.svg#general--not_available" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.notAvailable' | ibeadmin: 'sync'">
                            </app-svg>
                        </div>
                        <h5 class="title-h5">{{'addMoreSidebars.seatmap.title.notAvailable' | ibeadmin:'sync'}}</h5>
                    </div>
                </div>
            </div>

            <!-- Emergency -->
            <div *ngIf="emergencySeatNotificationOpen" class="compare-seats-step seatmap__body-content-wrapper">
                <h5 class="title-h5">
                    {{'addMoreSidebars.seatmap.title.emergencyRowSeatRequirements' | ibeadmin:'sync'}}
                </h5>
                <ul>
                    <li>
                        {{'addMoreSidebars.seatmap.list.emergencyRowSeatRequirement1' | ibeadmin:'sync'}}
                    </li>
                    <li>
                        {{'addMoreSidebars.seatmap.list.emergencyRowSeatRequirement2' | ibeadmin:'sync'}}
                    </li>
                    <li>
                        {{'addMoreSidebars.seatmap.list.emergencyRowSeatRequirement3' | ibeadmin:'sync'}}
                    </li>
                    <li>
                        {{'addMoreSidebars.seatmap.list.emergencyRowSeatRequirement4' | ibeadmin:'sync'}}
                    </li>
                    <li>
                        {{'addMoreSidebars.seatmap.list.emergencyRowSeatRequirement5' | ibeadmin:'sync'}}
                    </li>
                </ul>
                <button class="button" title="{{'addMoreSidebars.seatmap.aria.confirmSeatSelection' |  ibeadmin:'sync'}}" (click)="INDRA_confirmEmergencySeat()">
					{{ 'addMoreSidebars.seatmap.button.confirm' | ibeadmin:'sync'}}
				</button>
                <div class="passenger__action">
                    <button class="button" title="{{'addMoreSidebars.seatmap.aria.goBackToSeatmap' |  ibeadmin:'sync'}}" style="margin-right: 0;" (click)="INDRA_cancelEmergencySeat()">
						{{ 'addMoreSidebars.seatmap.button.selectOtherSeat' | ibeadmin:'sync'}}
					</button>
                </div>
            </div>

            <!-- Important -->
            <div *ngIf="saveConfirmationInfoOpen && !isLoadingSeatmap" class="compare-seats-step seatmap__body-content-wrapper">
                <div *ngIf="INDRA_seatRemoved(); else normalWarning">
                    <p>
                        {{ 'addMoreSidebars.seatmap.text.importantConfirmInformation1' | ibeadmin:'sync'}}
                    </p>
                    <p>
                        {{ 'addMoreSidebars.seatmap.text.importantConfirmInformation2' | ibeadmin:'sync'}}
                    </p>
                </div>
                <ng-template #normalWarning>
                    <p>
                        {{ 'addMoreSidebars.seatmap.text.importantConfirmInformation1' | ibeadmin:'sync'}}
                    </p>
                    <p>
                        {{ 'addMoreSidebars.seatmap.text.importantConfirmInformation2' | ibeadmin:'sync'}}
                    </p>
                    <p>
                        {{ 'addMoreSidebars.seatmap.text.importantConfirmInformation3' | ibeadmin:'sync'}}
                    </p>
                    <h4 class="title-h4">
                        {{ 'addMoreSidebars.seatmap.text.importantInfoClientsTitle' | ibeadmin:'sync'}}
                    </h4>
                    <p>
                        {{ 'addMoreSidebars.seatmap.text.importantInfoClientsText' | ibeadmin:'sync'}}
                    </p>
                    <div id="seat_link_container">
                        <a class="link link--external" target="_blank" aria-label="Know more about your seats" href="javascript:" (click)="INDRA_goToExemptionURL('externalURLs.seatExemption')">
                            {{ 'addMoreSidebars.seatmap.text.importantInfoClientsLink' | ibeadmin:'sync'}}
                        </a>
                    </div>
                </ng-template>
                <button class="button" title="{{'addMoreSidebars.seatmap.aria.confirmSeatSelection' |  ibeadmin:'sync'}}" (click)="INDRA_confirmSaveConfirmationInfo()">
					{{ 'addMoreSidebars.seatmap.button.keepSelection' | ibeadmin:'sync'}}
				</button>
                <div class="passenger__action">
                    <button class="button" title="{{'addMoreSidebars.seatmap.aria.cancelAndGoBack' |  ibeadmin:'sync'}}" style="margin-right: 0;" (click)="INDRA_cancelSaveConfirmationInfo()">
						{{ 'addMoreSidebars.seatmap.button.removeSelection' | ibeadmin:'sync'}}
					</button>
                </div>
            </div>
        </ng-container>


        <ng-template #disableForFlight>
            <app-notification *ngIf="segmentApiErrors.includes(flightStop.idInfoSegment) || addedByPack" [style]="'alert'" [classes]="'alert-sidebar'" [icon]="'icons.svg#airport--delays'" title="{{ 'addMoreSidebars.seatmap.title.seatMapNotAvailable'  | ibeadmin:'sync'}}">
                <div message>
                    {{ 'addMoreSidebars.seatmap.text.seatMapNotAvailable' | ibeadmin:'sync'}} {{INDRA_getLocation(flightStop.departureAirport)}} {{ 'addMoreSidebars.seatmap.text.to' | ibeadmin:'sync'}} {{INDRA_getLocation(flightStop.arrivalAirport)}}.
                </div>
            </app-notification>
        </ng-template>

    </div>

    <!-- SELECT PASSENGER -->
    <div #selectPassengerModal class="select-passenger" *ngIf="isOpen">
        <div class="select-passenger-overlay" (click)="closeSelectPassengerModal(false, $event)"></div>
        <div class="select-passenger-container" tabindex="0" #selectPassenger id="selectPassenger" [attr.aria-label]="
				   ('addMoreSidebars.seatmap.alt.selectPassengerFor' | ibeadmin: 'sync') +
				   seatType +
				   ('addMoreSidebars.seatmap.alt.seat' | ibeadmin: 'sync') +
				   selectedSeat.seatCode
         " cdkTrapFocus>
            <div class="select-passenger-header {{ seatColor }}">
                <p>{{ seatType | ibeadmin:'sync'}}</p>
                <p class="bold" *ngIf="selectedSeat">{{ selectedSeat.seatCode }}</p>
            </div>
            <div tabindex="-1" #sidebar__info class="sidebar__info {{seatColor+'_seat'}}">
                <ul class="vantages-listing">
                    <li *ngIf="hasUnaccompaniedMinor && selectedSeat.suitableUnnacompaniedMinor">
                        {{ 'addMoreSidebars.seatmap.text.suitableForUMNR' | ibeadmin:'sync'}}
                    </li>
                    <li *ngIf="INDRA_stopHasPurchasedCode('BSCT') && INDRA_isSelectedSeatSuitableHasCharacteristic('B')">
                        {{ 'addMoreSidebars.seatmap.text.suitableForBassinet' | ibeadmin:'sync'}}
                    </li>
                    <li *ngIf="INDRA_stopHasPurchasedCode('PETC') && INDRA_isSelectedSeatSuitableHasCharacteristic('PC')">
                        {{ 'addMoreSidebars.seatmap.text.suitableForPet' | ibeadmin:'sync'}}
                    </li>
                    <li *ngFor="let feature of seatFeatures; trackBy: trackByFn">
                        {{ feature | ibeadmin:'sync'}}
                    </li>
                </ul>
                <a #seatPhotos href="javascript:;" tabindex="0" *ngIf="INDRA_showSeatPhotos(seatCharacteristicsType)" class="bold seat-photos-link" style="color: white" [attr.aria-label]="INDRA_printSeatPhotosAriaLabel()" (click)="INDRA_openSlideshow(seatCharacteristicsType)">
                    <app-svg class="seat-photos-icon" style="fill:white" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.galleryIcon' | ibeadmin" svg="icons.svg#interface--gallery">
                    </app-svg>
                    {{'addMoreSidebars.seatmap.link.seatPhotos' | ibeadmin:'sync'}}
                </a>
            </div>
            <form class="select-passenger-list" *ngFor="
					let passengerInfo of INDRA_getPassengers();
					let index = index;
					trackBy: trackByFn">
                <div tabindex="0" class="list-passenger" [ngClass]="INDRA_passengerClasses(passengerInfo, index)" (keydown.enter)="INDRA_selectPassengerAction(passengerInfo, index)" (click)="INDRA_selectPassengerAction(passengerInfo, index)" *ngIf="INDRA_isSelectedSeatSuitableForPax(passengerInfo)">
                    <div class="radio">
                        <label class="radio__label" for="passenger-{{ index }}">
							{{ INDRA_printPassengerName(passengerInfo) }}
							<span *ngIf="INDRA_passengerIsMilesGo(passengerInfo.passenger)">
								{{ INDRA_printPassengerTierLevel(passengerInfo.passenger) }}
							</span>
							<span *ngIf="passengerInfo.adtToInf">
								{{'addMoreSidebars.seatmap.text.with' | ibeadmin:'sync'}} {{ INDRA_printInfantName(passengerInfo.adtToInf) }}
							</span>
						</label>
                        <div class="list-passenger-radio"></div>
                        <app-svg svg="icons.svg#general--check" class="list-passenger-radio--check"></app-svg>
                    </div>
                    <div class="align-right">
                        <p>
                            <s class="stricked_price" *ngIf="INDRA_getPassengerSeatMnbPrice(passengerInfo, index) != null">
								{{ INDRA_getPassengerSeatMnbPrice(passengerInfo, index)}}
                            </s>
                            <span class="bold">{{ INDRA_printPassengerSeatLabel(passengerInfo, index) }}</span>
                        </p>
                        <a class="link--small list-passenger-change-label">
							{{'addMoreSidebars.seatmap.link.changeTo' | ibeadmin:'sync'}}
							<span class="bold">
								{{ INDRA_getSelectedSeat() }}
							</span> -
							<s class="stricked_price" *ngIf="INDRA_getPassengerSeatMnbPrice(passengerInfo, index) != null">
								{{ INDRA_getPassengerSeatMnbPrice(passengerInfo, index)}}
                            </s>
							<span class="bold">
								{{ INDRA_getPassengerSeatPrice(passengerInfo, index)}}
							</span>
						</a>
                    </div>
                </div>
            </form>
        </div>

    </div>

    <!-- FOOTER STICKY -->
    <div #sidebar__footer class="sidebar__footer" *ngIf="!isLoadingSeatmap &&
								!emergencySeatNotificationOpen &&
								!saveConfirmationInfoOpen &&
								INDRA_avaibleForFlight()">


        <div class="sidebar__footer-options sidebar__footer-options--confirmation" *ngIf="hasChanges && !this.seatCharacteristicsOpen">
            <div class="sidebar__payment_totals">
                <div class="flow_actions" [ngClass]="INDRA_flowActionsClasses()" *ngIf="!isModificationDisallowed">
                    <button class="button" (click)="INDRA_handleNext()" [attr.aria-label]="'addMoreSidebars.seatmap.aria.selectForNextFlight' |  ibeadmin:'sync'" *ngIf="INDRA_hasNextFlight()">
						{{ 'addMoreSidebars.seatmap.button.selectForNextFlight' | ibeadmin:'sync'}}
					</button>
                    <button class="button" [disabled]="INDRA_disableSave()" (click)="INDRA_saveSidebar()" [attr.aria-label]="'addMoreSidebars.seatmap.aria.confirmSeatSelectionAndCloseDialog' |  ibeadmin:'sync'">
						{{ 'addMoreSidebars.seatmap.button.save' | ibeadmin:'sync'}}
					</button>
                </div>
                <div class="total">
                    <label class="label">
						{{ INDRA_printItemsCount() }} {{ 'addMoreSidebars.seatmap.text.items' | ibeadmin:'sync'}}
					</label>
                    <p class="value">{{ INDRA_printTotal() }}</p>
                </div>
            </div>
        </div>
        <ng-container *ngIf="!INDRA_printItemsCount() && !this.seatCharacteristicsOpen">
            <div class="sidebar__footer-options" *ngIf="INDRA_isCabinClassEconomy()">
                <div class="seatmap seat-charact" style="background: none;">
                    <div class="seat-charact-header" *ngIf="planeSeatTypesList.has('legroom')">
                        <div class="seat-charact-title">
                            <div class="seatmap__seat seat--legroom"></div>
                            <h5 class="footer-legend">{{ 'addMoreSidebars.seatmap.text.legSpace' | ibeadmin:'sync'}}</h5>
                        </div>
                    </div>
                    <div class="seat-charact-header" *ngIf="planeSeatTypesList.has('comfort')">
                        <div class="seat-charact-title">
                            <div class="seatmap__seat seat--comfort"></div>
                            <h5 class="footer-legend">{{ 'addMoreSidebars.seatmap.text.comfort' | ibeadmin:'sync'}}</h5>
                            
                        </div>
                    </div>
                    <div class="seat-charact-header" *ngIf="planeSeatTypesList.has('emergency')">
                        <div class="seat-charact-title">
                            <div class="seatmap__seat seat--emergency"></div>
                            <h5 class="footer-legend">{{ 'addMoreSidebars.seatmap.text.exitRow' | ibeadmin:'sync'}}</h5>
                            <!-- <app-svg svg="sprite.svg#logo--economy_extra" [alt]="'addMoreSidebars.seatmap.alt.economyXtra' | ibeadmin: 'sync'" class="seat-charact-logo seat-charact-logo--economy_xtra"></app-svg> -->
                        </div>
                    </div>
                    <div class="seat-charact-header">
                        <div class="seat-charact-title">
                            <div class="seatmap__seat seat--standard"></div>
                            <h5 class="footer-legend">
                                {{'addMoreSidebars.seatmap.text.standard' | ibeadmin:'sync'}}
                            </h5>
                            <!-- <app-svg svg="sprite.svg#logo--economy" [alt]="'addMoreSidebars.seatmap.alt.economy' | ibeadmin: 'sync'" class="seat-charact-logo seat-charact-logo--economy">
                            </app-svg> -->
                        </div>
                    </div>
                    <div class="seat-charact-header">
                        <div class="seat-charact-title">
                            <div class="seatmap__seat seat--not-available">
                                <app-svg class="seat-photos-icon" svg="icons.svg#general--not_available" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.notAvailable' | ibeadmin: 'sync'">
                                </app-svg>
                            </div>
                            <h5 class="footer-legend">{{'addMoreSidebars.seatmap.text.unavailable' | ibeadmin:'sync'}}</h5>
                        </div>
                    </div>
                    <!-- <a class="link" (click)="INDRA_handleOpenCharacteristics()" href="javascript:;" role="button">
                        {{ 'addMoreSidebars.seatmap.text.compare' | ibeadmin:'sync'}}
                    </a> -->
                </div>
            </div>
            <div class="sidebar__footer-options" *ngIf="INDRA_isCabinClassBusiness()">
                <div class="seatmap seat-charact" style="background: none;">
                    <div class="seat-charact-header">
                        <div class="seat-charact-title">
                            <div class="seatmap__seat seat--business"></div>
                            <h5 class="footer-legend">{{'addMoreSidebars.seatmap.text.executive' | ibeadmin:'sync'}}</h5>
                        </div>
                    </div>
                    <div class="seat-charact-header">
                        <div class="seat-charact-title">
                            <div class="seatmap__seat seat--not-available">
                                <app-svg class="seat-photos-icon" svg="icons.svg#general--not_available" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.notAvailable' | ibeadmin: 'sync'">
                                </app-svg>
                            </div>
                            <h5 class="footer-legend">{{'addMoreSidebars.seatmap.text.unavailable' | ibeadmin:'sync'}}</h5>
                        </div>
                    </div>
                </div>
                <!-- <a class="link" (click)="INDRA_handleOpenCharacteristics()" href="javascript:;" role="button">
					{{ 'addMoreSidebars.seatmap.link.compareSeat' | ibeadmin:'sync'}}
				</a> -->
            </div>
        </ng-container>

        <ng-container *ngIf="this.seatCharacteristicsOpen">
            <div class="sidebar__footer-options align-center">
                <a class="link" href="javascript:;" (click)="INDRA_handleCloseCharacteristics()" *ngIf="this.seatCharacteristicsOpen">
					{{ 'addMoreSidebars.seatmap.link.closeSeat' | ibeadmin:'sync'}}
				</a>
            </div>
        </ng-container>
    </div>
</div>